// src/components/parent-dashboard/utils/formatters.js

/**
 * Utility functions for formatting dates, calculating statistics, etc.
 */

// Format date for display (with time)
export const formatDate = (dateString) => {
    if (!dateString) return "No date set";

    const options = {year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'};
    return new Date(dateString).toLocaleDateString(undefined, options);
};

// Format simple date for display (no time)
export const formatSimpleDate = (dateString) => {
    if (!dateString) return "No date";

    const options = {year: 'numeric', month: 'long', day: 'numeric'};
    return new Date(dateString).toLocaleDateString(undefined, options);
};

// Format date for assignment display
export const formatSimpleDateAssignment = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date)) return 'Invalid Date'; // Handle invalid date strings
    return date.toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'});
};

// Get initials for avatar
export const getInitials = (name) => {
    if (!name) return "?";
    return name.split(' ').map(n => n[0]).join('').toUpperCase();
};

// Calculate attendance statistics
export const calculateAttendanceStats = (attendanceRecords) => {
    const totalRecords = attendanceRecords.length;
    if (totalRecords === 0) {
        return {
            total: 0,
            present: 0,
            absent: 0,
            percentage: 0,
        };
    }

    const presentCount = attendanceRecords.filter(record => record.present).length;
    const absentCount = totalRecords - presentCount;
    const percentage = (presentCount / totalRecords) * 100;

    return {
        total: totalRecords,
        present: presentCount,
        absent: absentCount,
        percentage: parseFloat(percentage.toFixed(1)), // Keep one decimal place
    };
};

// Get CSS class for attendance rate
export const getAttendanceRateClass = (rate) => {
    if (rate >= 90) return "text-green-600";
    if (rate >= 80) return "text-yellow-600";
    return "text-red-600";
};

// Get CSS class for attendance rate background
export const getAttendanceRateBgClass = (rate) => {
    if (rate >= 90) return "bg-green-600";
    if (rate >= 80) return "bg-yellow-500";
    return "bg-red-500";
};

// Calculate average grade percentage
export const calculateAverageGrade = (classes) => {
    if (!classes || classes.length === 0) return 0;

    // Map grades to percentages
    const gradeToPercent = g => {
        if (g === "A+") return 98;
        if (g === "A") return 93;
        if (g === "A-") return 88;
        if (g === "B+") return 83;
        if (g === "B") return 78;
        if (g === "C") return 70;
        return 60;
    };

    const gradePercentages = classes.map(cls => gradeToPercent(cls.grade || 'C'));
    return Math.round(gradePercentages.reduce((a, b) => a + b, 0) / gradePercentages.length);
};